import isEmpty from 'lodash/isEmpty';
import pickBy from 'lodash/pickBy';
import type { NextRouter } from 'next/router';
import Router from 'next/router';

import { getRouteParams } from '@src/helpers/query';

const toString = (query: Record<string, any>) => {
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params.set(key, String(value));
    }
  });
  const str = params.toString();
  return str ? `?${str}` : '';
};

export const mergeQueryReplace = (
  router: NextRouter,
  query: NextRouter['query'],
  options: Partial<{ scroll: boolean; shallow: boolean }>,
) => {
  const routerParams = getRouteParams(router.query);
  const [asPath] = router.asPath.split('?');

  const newQuery = pickBy(query, (value, key) => !(key in routerParams));

  if (isEmpty(newQuery)) return;

  const mergedQuery = { ...routerParams, ...newQuery };

  const url = `${router.route}${toString(mergedQuery)}`;
  const as = `${asPath}${toString(newQuery)}`;

  if (as === router.asPath) return;

  return Router.replace(url, as, options);
};
